import { getHidratationKey } from '@portal-internet/core';
import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import __isEmpty from 'lodash/isEmpty';
import styles from './collaboracio.module.scss';
import Desplegable from 'components/corporatiu/Desplegable';

export default function Collaboracio(props) {
    const { items, links, lang } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <Text text={items?.entradeta} className='gapAfter' />

            {!__isEmpty(links) &&
                links?.desplegables.map((item, index) => (
                    <div key={`collaboracio-${index}`}>
                        <Desplegable
                            key={getHidratationKey(item?.[`titol_${lang}`])}
                            titol={item?.[`titol_${lang}`]}
                            className={styles.textDesplegable}
                        >
                            <div className={styles.contingutDesplegable}>
                                <Text text={item?.text} />
                            </div>
                        </Desplegable>
                    </div>
                ))}

            <Titol titol={items?.titol2} tag='h2' />
            <Text text={items?.entradeta2} className='gapAfter' />

            {!__isEmpty(items) &&
                items?.desplegables2.map((item, index) => (
                    <div key={index}>
                        <>
                            <Desplegable
                                key={getHidratationKey(item?.titol)}
                                titol={item?.titol}
                                className={styles.textDesplegable}
                            >
                                <div className={styles.contingutDesplegable}>
                                    <Text text={item?.text} />
                                </div>
                            </Desplegable>
                        </>
                    </div>
                ))}

            <Text text={items?.entradeta3} />

            <Titol titol={items?.titol4} tag='h2' />
            <Text text={items?.entradeta4} />
        </>
    );
}
